export default {
  layout: {
    backToHome: 'Back to Home',
    legalDocuments: 'Legal Documents',
    product: 'Product',
    developers: 'Developers',
    company: 'Company',
    legal: 'Legal',
  },
  nav: {
    markets: 'Markets',
    aiAgents: 'AI Agents',
    vaults: 'Vaults',
    leaderboard: 'Leaderboard',
    fees: 'Fees',
    apiReference: 'API Reference',
    sdks: 'SDKs',
    about: 'About ZhiSu',
    careers: 'Careers',
    contact: 'Contact',
    press: 'Press & Media',
    brand: 'Brand Guidelines',
    terms: 'Terms of Service',
    privacy: 'Privacy Policy',
    cookies: 'Cookie Policy',
    aml: 'AML Policy',
    risk: 'Risk Disclosure',
    agreement: 'User Agreement',
  },
  table: {
    pair: 'Pair',
    price: 'Price',
    change24h: '24h Change',
    volume24h: '24h Volume',
    funding: 'Funding',
    high24h: '24h High',
    low24h: '24h Low',
    rank: 'Rank',
    trader: 'Trader',
    pnl30d: 'PNL (30d)',
    winRate: 'Win Rate',
    method: 'Method',
    endpoint: 'Endpoint',
    description: 'Description',
    auth: 'Auth',
    required: 'Required',
    none: 'None',
    trades: 'Trades',
    volume: 'Volume',
    followers: 'Followers',
  },
  common: {
    lastUpdated: 'Last Updated',
  },
  markets: {
    title: 'Markets',
    subtitle: 'Trade perpetual futures on 50+ cryptocurrency pairs with up to 50x leverage',
  },
  aiAgents: {
    title: 'AI Agents',
    subtitle: 'Deploy autonomous AI trading agents with machine-learned strategies',
    pnl30d: 'PNL (30d)',
    winRate: 'Win Rate',
    trades24h: 'Trades (24h)',
    risk: 'Risk',
    avgHold: 'Avg Hold',
  },
  vaults: {
    title: 'Vaults',
    subtitle: 'Automated yield-generating strategy vaults with built-in risk management',
    tvl: 'TVL',
    apy: 'APY',
    depositors: 'Depositors',
    minDeposit: 'Min Deposit',
    riskLevel: 'Risk Level',
    low: 'Low',
    medium: 'Medium',
    high: 'High',
  },
  leaderboard: {
    title: 'Leaderboard',
    subtitle: 'Top-performing traders ranked by 30-day PnL',
    allTime: 'All Time',
    weekly: 'Weekly',
  },
  fees: {
    title: 'Fees',
    subtitle: 'Transparent and competitive fee structure for all traders',
    tier: 'Tier',
    maker: 'Maker',
    taker: 'Taker',
    volume30d: '30d Volume',
    holderRequirement: 'HOLDER Requirement',
    fundingRate: 'Funding Rate',
    fundingLong: 'Longs pay shorts when positive',
    fundingShort: 'Shorts pay longs when negative',
    withdrawalFees: 'Withdrawal Fees',
    asset: 'Asset',
    networkFee: 'Network Fee',
    minWithdrawal: 'Min Withdrawal',
    perpetualTrading: 'Perpetual Trading',
    interval: 'Interval',
    settlement: 'Settlement',
    maxRate: 'Max Rate',
  },
  apiReference: {
    title: 'API Reference',
    subtitle: 'Complete REST API documentation for market data, trading, and account management',
    baseUrl: 'Base URL',
    authentication: 'Authentication',
    authDesc: 'Public endpoints do not require authentication. Authenticated endpoints require an API key passed in the X-API-Key header.',
    rateLimits: 'Rate Limits',
    public: 'Public',
    authenticated: 'Authenticated',
    websocket: 'WebSocket',
    epMarkets: 'List all available trading markets',
    epTicker: 'Get 24h ticker data for a specific market',
    epOrderbook: 'Get orderbook depth for a specific market',
    epTrades: 'Get recent trades for a specific market',
    epAccount: 'Get account balance and positions',
    epOrders: 'Place a new order',
    epCancelOrder: 'Cancel an existing order',
    epOrdersList: 'List active orders',
    epFills: 'Get historical fills',
    epFundingRates: 'Get current funding rates for all markets',
  },
  sdks: {
    title: 'SDKs',
    subtitle: 'Official SDKs for Python, TypeScript, Rust, and Go',
    install: 'Install',
    documentation: 'Documentation',
    pythonDesc: 'Full-featured Python client for REST API and WebSocket streaming. Supports async/await, type hints, and automatic reconnection.',
    tsDesc: 'Modern TypeScript/JavaScript client with full type safety, built-in retry logic, and browser/Node.js compatibility.',
    rustDesc: 'High-performance Rust client optimized for low-latency trading bots and quantitative strategies.',
    goDesc: 'Lightweight Go client with concurrent WebSocket support and efficient memory management for high-frequency applications.',
  },
  about: {
    title: 'About ZhiSu',
    subtitle: 'Building the future of decentralized derivatives trading',
    ourValues: 'Our Values',
    leadershipTeam: 'Leadership Team',
    backedBy: 'Backed By',
    decentralization: 'Decentralization',
    decentralizationDesc: 'We believe in a world where financial markets operate without intermediaries. Every trade on ZhiSu is settled on-chain, giving users full custody of their assets at all times.',
    innovation: 'Innovation',
    innovationDesc: 'We push the boundaries of what is possible in DeFi. From AI-powered trading agents to cross-chain liquidity aggregation, we are building the infrastructure for the next generation of finance.',
    transparency: 'Transparency',
    transparencyDesc: 'All protocol operations, fee structures, and governance decisions are open and auditable. Our smart contracts are publicly verified, and our roadmap is shared with the community.',
    security: 'Security',
    securityDesc: 'Security is not an afterthought. Our code undergoes multiple independent audits, and we operate a comprehensive bug bounty program to ensure the safety of user funds.',
    founded: 'Founded in 2024, ZhiSu is a next-generation decentralized derivatives exchange built on cutting-edge blockchain infrastructure.',
    volume: 'With over $2.8 billion in cumulative trading volume and a growing ecosystem of AI-powered trading agents, ZhiSu has become one of the most trusted platforms in the DeFi space.',
    teamDesc: 'Our team brings together expertise from leading quantitative hedge funds, traditional finance institutions, and top blockchain protocols.',
    totalVolume: 'Total Volume',
    activeTraders: 'Active Traders',
    markets: 'Markets',
    countries: 'Countries',
    ceo: 'Chief Executive Officer',
    cto: 'Chief Technology Officer',
    headProduct: 'Head of Product',
    headAI: 'Head of AI Research',
    clo: 'Chief Legal Officer',
    headEng: 'Head of Engineering',
  },
  careers: {
    title: 'Careers',
    subtitle: 'Join the team building the future of AI-native trading infrastructure',
    openPositions: 'Open Positions',
    allDepartments: 'All Departments',
    engineering: 'Engineering',
    product: 'Product',
    design: 'Design',
    marketing: 'Marketing',
    operations: 'Operations',
    legal: 'Legal',
    location: 'Location',
    type: 'Type',
    applyNow: 'Apply Now',
    benefits: 'Why Join ZhiSu',
    benefit1Title: 'Competitive Compensation',
    benefit1Desc: 'Above-market salaries, token allocations, and performance bonuses.',
    benefit2Title: 'Remote First',
    benefit2Desc: 'Work from anywhere. We are a globally distributed team.',
    benefit3Title: 'Cutting Edge Tech',
    benefit3Desc: 'Build with the latest in AI, blockchain, and distributed systems.',
    benefit4Title: 'Growth',
    benefit4Desc: 'Rapid career progression in a fast-growing industry.',
  },
  contact: {
    title: 'Contact',
    subtitle: 'Get in touch with our team',
    generalInquiries: 'General Inquiries',
    support: 'Support',
    press: 'Press',
    partnerships: 'Partnerships',
    sendMessage: 'Send Message',
    name: 'Name',
    email: 'Email',
    subject: 'Subject',
    message: 'Message',
    followUs: 'Follow Us',
    response: 'We typically respond within 24 hours.',
  },
  press: {
    title: 'Press & Media',
    subtitle: 'Latest news and announcements from ZhiSu',
    mediaContact: 'Media Contact',
    pressEmail: 'press@zhisu.trade',
    readMore: 'Read More',
  },
  brand: {
    title: 'Brand Guidelines',
    subtitle: 'Official brand assets and usage guidelines',
    logoUsage: 'Logo Usage',
    colorPalette: 'Color Palette',
    typography: 'Typography',
    do: 'Do',
    dont: 'Don\'t',
    primary: 'Primary',
    secondary: 'Secondary',
    background: 'Background',
    accent: 'Accent',
    headingFont: 'Heading Font',
    bodyFont: 'Body Font',
    monoFont: 'Mono Font',
    logoRules1: 'Use the logo on dark or light backgrounds with sufficient contrast.',
    logoRules2: 'Maintain clear space around the logo equal to the height of the V mark.',
    logoRules3: 'Use the provided color variations for different backgrounds.',
  },
  terms: {
    title: 'Terms of Service',
    s1: '1. Acceptance of Terms',
    s2: '2. Eligibility',
    s3: '3. Description of Services',
    s4: '4. Account Registration and Security',
    s5: '5. Trading Rules and Risks',
    s6: '6. Fees and Charges',
    s7: '7. Prohibited Activities',
    s8: '8. Intellectual Property',
    s9: '9. Disclaimer of Warranties',
    s10: '10. Limitation of Liability',
    s11: '11. Indemnification',
    s12: '12. Governing Law and Dispute Resolution',
    s13: '13. Amendments',
    s14: '14. Contact Information',
  },
  privacy: {
    title: 'Privacy Policy',
    s1: '1. Introduction',
    s2: '2. Information We Collect',
    s3: '3. How We Use Your Information',
    s4: '4. Legal Basis for Processing',
    s5: '5. Information Sharing and Disclosure',
    s6: '6. Data Security',
    s7: '7. Data Retention',
    s8: '8. Your Rights',
    s9: '9. International Data Transfers',
    s10: "10. Children's Privacy",
    s11: '11. Changes to This Policy',
    s12: '12. Contact Us',
  },
  cookies: {
    title: 'Cookie Policy',
    s1: '1. What Are Cookies',
    s2: '2. How We Use Cookies',
    s3: '3. Types of Cookies We Use',
    s4: '4. Third-Party Cookies',
    s5: '5. Managing Your Cookie Preferences',
    s6: '6. Web Beacons and Similar Technologies',
    s7: '7. Do Not Track Signals',
    s8: '8. Changes to This Policy',
    s9: '9. Contact Us',
  },
  aml: {
    title: 'AML Policy',
    s1: '1. Policy Statement',
    s2: '2. Regulatory Framework',
    s3: '3. Customer Due Diligence (CDD)',
    s4: '4. Ongoing Monitoring',
    s5: '5. Prohibited Activities',
    s6: '6. Sanctions Compliance',
    s7: '7. Suspicious Activity Reporting',
    s8: '8. Record Keeping',
    s9: '9. Staff Training',
    s10: '10. Independent Audit',
    s11: '11. Contact',
  },
  risk: {
    title: 'Risk Disclosure',
    s1: '1. Important Notice',
    s2: '2. Not Financial Advice',
    s3: '3. Market Risks',
    s4: '4. Leverage and Margin Risks',
    s5: '5. Smart Contract and Technical Risks',
    s6: '6. AI Agent and Automated Trading Risks',
    s7: '7. Custody and Wallet Risks',
    s8: '8. Regulatory and Compliance Risks',
    s9: '9. Cybersecurity Risks',
    s10: '10. Total Loss Risk',
    s11: '11. No Guarantee of Platform Availability',
    s12: '12. Acknowledgment',
    s13: '13. Contact',
  },
  agreement: {
    title: 'User Agreement',
    s1: '1. Agreement Overview',
    s2: '2. Definitions',
    s3: '3. Account and Wallet Connection',
    s4: '4. Trading Rules',
    s5: '5. Fees and Payments',
    s6: '6. AI Agents and Automated Services',
    s7: '7. API Usage',
    s8: '8. Representations and Warranties',
    s9: '9. Termination',
    s10: '10. Dispute Resolution',
    s11: '11. Modifications',
    s12: '12. Entire Agreement',
    s13: '13. Contact',
  },
  skills: {
    title: 'Skills',
    subtitle: 'Discover and install community-built skills for your AI agents',
    searchPlaceholder: 'What are you looking for?',
    install: 'Install',
    installNow: 'Install',
    categories: {
      all: 'All',
      defi: 'DeFi & Trading',
      social: 'Social & Messaging',
      tools: 'Analytics & Tools',
      other: 'Other',
    },
    stats: {
      tools: 'tools',
      users: 'users',
      downloads: 'downloads',
      rating: 'avg rating',
    },
    featuredSkills: 'Featured Skills',
    trendingNow: 'Trending Now',
    viewAll: 'View all',
    allSkills: 'All Skills',
    searchResults: 'Search Results',
    noResults: 'No skills found matching your criteria.',
    builtByCommunity: 'Built by the community',
    equip: 'Equip',
    unleash: 'Unleash',
    toolsReady: 'Tools built by thousands, ready in one search.',
    installCommand: 'Install Command',
    copied: 'Copied!',
    copy: 'Copy',
    about: 'About',
    usageExample: 'Usage Example',
    info: 'Information',
    related: 'Related Skills',
    backToSkills: 'Back to Skills',
    notFound: 'Skill not found',
    notFoundDesc: 'The skill you are looking for does not exist.',
  },
};